import { Component, EventEmitter, Input, OnInit, Output, ViewChild, AfterViewInit } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { ILabelRow } from '../labels.service';
import { SharedNotificationService } from '../shared-notification.service';

interface iSelectLabelRow extends ILabelRow {
    selected?: boolean;
}

@Component({
    selector: 'app-labels-table',
    templateUrl: './labels-table.component.html',
    styleUrls: ['./labels-table.component.scss']
})
export class LabelsTableComponent implements OnInit, AfterViewInit {

    @Output()
    onSelectionChange = new EventEmitter<iSelectLabelRow[]>();
    @Output()
    pageChange = new EventEmitter<PageEvent>();

    @Input()
    pageIndex: number = 0;
    @Input()
    pageSize: number = 100;
    @Input()
    totalCount: number = 0;

    sort: MatSort;
    @ViewChild(MatSort, { static: false }) set matSort(ms: MatSort) {
        this.sort = ms;
        this.setDatasourceData();
    }

    @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

    numberOfLabels: number = 0;
    isAllSelected: boolean;
    selectedItems: iSelectLabelRow[] = [];
    saveButtonIsEnabled: boolean;

    displayedColumns: string[] = [
        'labelIsCreated',
        'orderNr',
        'datumAangemaakt',
        'debiteurNrs',
        'leverDatumTijdstip',
        'leverTijdstip',
        'kwekerArtikelNr',
        'klantArtikelOmschrijving',
        'potmaat',
        'barCode',
        'aantalFustLabels',
        'fustStickerlocatie',
        'aantalProductLabels',
        'productStickerlocatie',
        'aanleverwijze',
        'afmetingStickers',
        'opmerkingInstructie'
    ];

    @Input() onlyShowPrintedRegels: boolean;
    _data: iSelectLabelRow[];

    @Input()
    public get data() {
        return this._data;
    }
    public set data(value: iSelectLabelRow[]) {
        this._data = value;
        this.setDatasourceData();
    }

    dataSource: MatTableDataSource<iSelectLabelRow> = new MatTableDataSource<iSelectLabelRow>();
    
    constructor(
        private _notificationService: SharedNotificationService) {
        this.isAllSelected = false;
        this.onlyShowPrintedRegels = false;
        this.saveButtonIsEnabled = false;
        this._data = [];
    }

    ngOnInit() {
        this.setDatasourceData();
        this.selectedItems = [];

        this._notificationService.onPrintPrintedLabelsObservable.subscribe({
            next: (x: boolean) => { if (x) { console.log('Received onPrintPrintedLabels event'); this.selectedItems = []; this.setSelectedItems(); } },
            error: (err: Error) => console.error('Something went wrong setting selectedItems onPrintPrintedLabels next value. Retrieved an error: ' + err)
        });

        this._notificationService.onPrintUnprintedLabelsObservable.subscribe({
            next: (x: boolean) => { if (x) { console.log('Received onPrintUnprintedLabels event'); this.selectedItems = []; this.setSelectedItems(); } },
            error: (err: Error) => console.error('Something went wrong setting selectedItems onPrintUnprintedLabels next value. Retrieved an error: ' + err)
        });
    }

    ngAfterViewInit() {
        if (this.paginator) {
            this.paginator.pageIndex = this.pageIndex || 0;
            this.paginator.pageSize = this.pageSize || 100;
        }
    }

    setDatasourceData() {
        this.dataSource.sort = this.sort;
        if (this.paginator) {
            this.dataSource.paginator = null;
        }
        if (this._data) {
            this.setSelectedItems();
            this.dataSource.data = this._data;
            this.isAllSelected = this._data.every(row => row.selected);
        }
    }

    onPage(event: PageEvent) {
        this.pageChange.emit(event);
    }

    setSelectedItems() {
        if (!this.selectedItems || !this.selectedItems.length) {
            this.selectedItems = [];
            this._data.forEach((item) => {
                item.selected = false;
                this.toggleSelected(item);
            });
        }
        else {
            this.selectedItems.forEach((selectedItem) => {
                var items = this._data.filter(x => x.id == selectedItem.id);
                if (items && items.length) {
                    var item = items[0];
                    item.selected = selectedItem.selected;
                    this.toggleSelected(item);
                }
            });
        }
    }

    toggleSelected(item: iSelectLabelRow): void {
        this.toggleSelectedItem(item, item.selected);
        this.isAllSelected = this._data.every(row => row.selected);
        this.onSelectionChange.emit(this.selectedItems);
    }

    toggleSelectedItem(item: ILabelRow, isSelected: boolean) {
        var itemInArray = this.selectedItems.filter(x => x.id == item.id);
        if (itemInArray && itemInArray.length == 1) {
            if (isSelected == true) {
                itemInArray[0].selected = true;
            }
            else if (isSelected == false) {
                var indexOf = this.selectedItems.indexOf(itemInArray[0]);
                this.selectedItems.splice(indexOf, 1);
            }
        }
        else if (!itemInArray || itemInArray.length == 0) {
            if (isSelected == true) {
                this.selectedItems.push(item);
            }
        }
    }

    markAll() {
        let printed = this.isAllSelected;
        this.data.forEach((item) => {
            item.selected = printed;
            this.toggleSelectedItem(item, printed);
        });
        this.onSelectionChange.emit(this.selectedItems);
    }

    trackById(index, item) {
        return item.id;
    }
}